import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../customAxios.js";
import { Grid, Button } from "@mui/material";
import CopyButton from "../components/CopyButton";
import LoadingComponent from "../components/LoadingComponent";

function ProductDetail(props) {
  const navigate = useNavigate();
  const product_id = useParams().productId;
  const [data, setData] = useState({});

  const [imageLoaded, setImageLoaded] = useState(false);
  const [timeoutReached, setTimeoutReached] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);

  const imageUrl = localStorage.getItem("productDetailUrl");

  //USE EFFECT TO DETECT WHEN ALL IMAGES ARE LOADED
  useEffect(() => {
    const image = new Image();
    image.src = imageUrl;
    const imageElement = image;

    const checkImageLoaded = () => {
      const loaded = imageElement.complete && imageElement.naturalHeight !== 0;
      if (loaded) {
        setImageLoaded(true);
      }
    };

    imageElement.addEventListener("load", checkImageLoaded);

    return () => {
      imageElement.removeEventListener("load", checkImageLoaded);
    };
  }, []);

  //USE EFFECT TO DETECT WHEN TIMEOUT IS REACHED, IF IMAGES ARE NOT LOADED
  useEffect(() => {
    let timeoutId;

    // Set a timeout to check if images are not loaded within 10000 milliseconds (10 seconds)
    timeoutId = setTimeout(() => {
      // If images are not loaded, set timeoutReached to true
      if (!imageLoaded) {
        console.log("timeout reached");
        setTimeoutReached(true);
      }
    }, 5000);

    // Cleanup: Clear the timeout on unmount
    return () => {
      clearTimeout(timeoutId);
    };
  }, [imageLoaded]);

  async function fetchInventoryProduct() {
    try {
      const { data } = await axios.get(
        `products/product_detail/${product_id}/`
      );
      setData(data);
    } catch (error) {
      console.error(`Error al cargar el detalle del producto: ${error}`);
    } finally {
      setDataLoaded(true);
    }
  }

  useEffect(() => {
    fetchInventoryProduct();
  }, []);

  if ((imageLoaded && dataLoaded) || timeoutReached) {
    return (
      <>
        <Grid item xs={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <Button
              variant="outlined"
              style={{ marginRight: "10px" }}
              onClick={() => navigate(-1)}
            >
              ← Regresar
            </Button>
            <h1>Detalle producto</h1>
          </div>
        </Grid>

        <Grid container>
          <Grid item xs={6} style={{ borderRight: "1px solid #d3d3d3" }}>
            <Grid container style={{ marginBottom: "15px" }}>
              <Grid item xs={6}>
                <div className="product-image-container-product-details">
                  <img
                    src={imageUrl}
                    alt={data.product.name}
                    className="product-image-product-details"
                  />
                </div>
              </Grid>
              <Grid item xs={6}>
                <div
                  style={{
                    marginLeft: "10%",
                    marginRight: "10%",
                    marginTop: "15%",
                  }}
                >
                  <div className="product-name-product-details">
                    {data.product.name}
                  </div>
                  <div
                    className="copy-button-product-details"
                    style={{ marginTop: "15px" }}
                  >
                    <CopyButton
                      textToCopy={data.product.sku}
                      labelName={"SKU: "}
                      uniqueId={"sku"}
                    />
                  </div>
                  <div className="copy-button-product-details">
                    <CopyButton
                      textToCopy={data.product.barcode}
                      labelName={"Barcode: "}
                      uniqueId={"barcode"}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            {/* <Grid container style={{marginLeft: "50px"}}>
              <Grid item xs={6}>
                <div style={{fontFamily: "bold", color: "#2B2B2B"}}>
                  CANAL
                </div>
              </Grid>
              <Grid item xs={6}>
                <div style={{fontFamily: "bold", color: "#2B2B2B"}}>
                  PRECIO
                </div>
              </Grid>
            </Grid> */}
          </Grid>
          <Grid item xs={12} style={{ borderTop: "1px solid #d3d3d3" }}>
            <Grid
              container
              className="grid-titles-product-details"
              style={{ marginTop: "30px" }}
            >
              <Grid item xs={4}>
                <div>UBICACIÓN</div>
              </Grid>
              <Grid item xs={4}>
                <div>STOCK (IDEAL)</div>
              </Grid>
              <Grid item xs={4}>
                <div>STOCK (REAL)</div>
              </Grid>
              {/* <Grid item xs={3}>
                <div>
                  CANAL
                </div>
              </Grid> */}
            </Grid>
            {data.warehouses.map((warehouse, index) => {
              return (
                <Grid container className="grid-rows-container-product-details">
                  <Grid item xs={4}>
                    <div>{warehouse.name}</div>
                  </Grid>
                  <Grid item xs={4}>
                    <div>{warehouse.total_ideal_stock}</div>
                  </Grid>
                  <Grid item xs={4}>
                    <div>{warehouse.total_real_stock}</div>
                  </Grid>
                  {/* <Grid item xs={3}>
                    <div>
                      <img src={logos_canales} alt="mercado libre logo" style={{maxHeight: "50px", maxWidth: "100%"}}/>
                    </div>
                  </Grid> */}
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </>
    );
  } else {
    return <LoadingComponent />;
  }
}

export default ProductDetail;
